module.exports = __webpack_public_path__ + "img/medium_brown.39af71ab.svg";